// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
 
background-color: #333;
/* background-color: #555; */
/* font-family: 'Ubuntu', sans-serif !important; */
font-family: "Roboto";
font-size: var(--font-size-small) !important ;
/* font-weight: bold; */
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif !important; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* font-family: Arial, Helvetica, sans-serif; */
}

.roboto-thin {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  font-style: normal;
}

.roboto-light {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.roboto-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.roboto-medium {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.roboto-bold {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.roboto-black {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: normal;
}

.roboto-thin-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  font-style: italic;
}

.roboto-light-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-style: italic;
}

.roboto-regular-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.roboto-medium-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: italic;
}

.roboto-bold-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: italic;
}

.roboto-black-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;;AAEX,sBAAsB;AACtB,4BAA4B;AAC5B,kDAAkD;AAClD,qBAAqB;AACrB,6CAA6C;AAC7C,uBAAuB;EACrB;;4BAE0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0;\n \nbackground-color: #333;\n/* background-color: #555; */\n/* font-family: 'Ubuntu', sans-serif !important; */\nfont-family: \"Roboto\";\nfont-size: var(--font-size-small) !important ;\n/* font-weight: bold; */\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif !important; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* font-family: Arial, Helvetica, sans-serif; */\n}\n\n.roboto-thin {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 100;\n  font-style: normal;\n}\n\n.roboto-light {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.roboto-regular {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.roboto-medium {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.roboto-bold {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.roboto-black {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-style: normal;\n}\n\n.roboto-thin-italic {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 100;\n  font-style: italic;\n}\n\n.roboto-light-italic {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.roboto-regular-italic {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.roboto-medium-italic {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.roboto-bold-italic {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-style: italic;\n}\n\n.roboto-black-italic {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
